import React, { Component } from 'react';

class GuideTitle extends Component {
    render() {
        const {title} = this.props.guide;
        return (
            <div className="title-header d-flex justify-content-center align-items-center w-100">
                <h1 className="title m-0" onClick={this.handleMove}>{title}</h1>
            </div>
        );
    }
}

export default GuideTitle;